import { useCallback } from 'react';

import { useTableDispatch } from '../context/TableSchemaBuilderContext';

export const useCellManagement = () => {
  const dispatch = useTableDispatch();

  const handleCellChange = useCallback(
    (cellId, value) => {
      dispatch({
        type: 'UPDATE_CELL_VALUE',
        payload: {
          cellId,
          value,
        },
      });
    },
    [dispatch]
  );

  return { handleCellChange };
};
